import { AuthScopeBase, AvengersRole, CrudOp, DifferentiationType, UndifferentiatedAuthScope } from "../authHelperTypes";

const CRUD = Object.values(CrudOp);
const R = [CrudOp.READ];

const undifferentiated = (mappings: AuthScopeBase["mappings"]): UndifferentiatedAuthScope => ({
  type: DifferentiationType.NONE,
  mappings,
});

// @formatter:off
// differentiation type: NONE
/* eslint-disable @stylistic/key-spacing */
export const projectOverviewAuthScope = undifferentiated({
  [AvengersRole.ADMIN]:               R,
  [AvengersRole.PROJECT_MANAGER]:     R,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            R,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const roleAssignmentOverviewAuthScope = undifferentiated({
  [AvengersRole.ADMIN]:               CRUD,
});

export const targetAuthScope = undifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const triggerAuthScope = undifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            R,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});
